module.exports = __webpack_public_path__ + "static/media/pres09.4b081441.png";